import { PriceProps } from "@Tmp/Price/Price.types";
import * as React from "react";
import ProductPrice from "@Tmp/Price";
import { useAxios, useUpdateEffect } from "@Tmp/Hooks";

const Price: React.FC<PriceProps> = ({ product: productProp, ...props }) => {
    const [product, setProduct] = React.useState(productProp);

    useUpdateEffect(() => {
        setProduct(productProp);
    }, [productProp]);

    const { status: fetchStatus, value: fetchValue } = useAxios(
        "get",
        "/wp-content/plugins/tmp/api/product.php",
        { id: productProp.id },
        [productProp],
        { autoRun: true }
    );

    useUpdateEffect(() => {
        if (fetchStatus === "success") {
            setProduct(fetchValue.data.item);
        }
    }, [fetchStatus]);

    return <ProductPrice product={product} {...props} />;
};

export default Price;
